import React, { Component, createRef } from 'react';
import { connect } from 'react-redux';
import Parameters from '@/services/Sierra/Sparameter/parameter';
import { SweepResultData } from '@/services/Sierra';
import { getResultList } from '@/services/helper/sparameter/dataProcess';
import { strDelimited } from '@/services/helper/split';
import Sparameter from '../components/Sparameter';
import makeCancelable from '@/services/api/makeCancelable';
import { getSweepMouseMoveYAxisValue, cancelSweepMove, sparameterShowCurves } from '../../../../services/Sierra/helper/sparameterDataHelper';
import resultOperation from '../../../../services/Result/Public/resultOperation';
import { CHANNEL } from '../../../../services/Result/Public/resultConstants';
import { RESULT } from '../../../../components/ResultTreeList/nodeRender';
import { RESULT_TREE_SIGNAL, RESULT_TREE_SWEEP_PIN } from '../components/resultTreeRender';

const defaultState = {
  files: [],
  displayFiles: [],
  portSelect: {},
  Interfaces: {},
  resultList: {},
  keepSelect: false,
  expandedKeys: []
}
class SweepChannel extends Component {

  constructor(props) {
    super(props);
    this.uploadSP = createRef();
    this.uploadSnpRef = createRef();
    const { expVerificationId } = props;
    const resultOpera = expVerificationId ? resultOperation.getOperationByKey(expVerificationId, CHANNEL) : {};
    this.state = {
      ...defaultState,
      resultOpera: resultOpera || {}
    }
    this.plot2d = null;
  }

  changeMouse = (frequency) => {
    try {

      let { files, resultList } = this.state;
      const displayMode = this.childComp.getDisplayMode();
      const axis = this.childComp.getAxis();
      const yScale = axis.yScale;
      const selectArr = this.childComp.getCurrentSelects();
      let _resultList = { ...resultList };
      for (let pcb in _resultList) {
        _resultList[pcb] = getSweepMouseMoveYAxisValue({
          resultsObj: _resultList[pcb],
          displayMode,
          selectArr,
          files,
          x: frequency,
          setting: this.childComp.getSetting(),
          yScale
        })
      }
      this.setState({
        resultList: _resultList
      });
    } catch (error) {
      console.error(error)
    }
  }

  cancelMove = () => {
    try {
      let { resultList } = this.state;
      const displayMode = this.childComp.getDisplayMode();
      let _resultList = { ...resultList };
      for (let pcb in _resultList) {
        _resultList[pcb] = cancelSweepMove({
          resultsObj: _resultList[pcb],
          displayMode
        })
      }
      this.setState({
        resultList: _resultList
      });
    } catch (error) {
      console.error(error)
    }
  }

  componentWillUnmount = () => {
    if (this.selectAllCancelAble) {
      this.selectAllCancelAble.cancel();
    }
  }

  componentDidUpdate(prevProps) {
    const { sweepListStatus, expKeyStatus, expVerificationId } = this.props;
    if (sweepListStatus && sweepListStatus !== prevProps.sweepListStatus) {
      this.props.updateSweepListStatus(false)
      const resultOpera = resultOperation.getOperationByKey(expVerificationId, CHANNEL) || {};
      this.setState({
        ...defaultState,
        portSelect: {},
        resultList: {},
        resultOpera
      });
      Parameters.cleanParameters();
      this.getInterface();
      if (this.selectAllCancelAble) {
        this.selectAllCancelAble.cancel();
      }
      if (this.childComp) {
        const { displayMode = 'Default' } = resultOpera;
        this.childComp.updateDisplayModeModel(displayMode)
      }
    }

    if (expKeyStatus && expKeyStatus !== prevProps.expKeyStatus) {
      this.props.updateExpKeyStatus(false)
      this.setState({
        resultList: {},
        files: [],
        displayFiles: [],
        Interfaces: {},
        keepSelect: true
      });
      Parameters.cleanParameters();
      this.getInterface();
      if (this.selectAllCancelAble) {
        this.selectAllCancelAble.cancel();
      }
    }
  }

  componentDidMount = async () => {
    const { currentProjectId, sweepId } = this.props;
    this.setState({
      ...defaultState,
      portSelect: {},
      resultList: {},
    });
    if (currentProjectId && sweepId) {
      this.getInterface();
    }
  }

  getInterface = async () => {
    const { experimentList, currentProjectId } = this.props;
    let Interfaces = {}
    for (let exp of experimentList) {
      const res = await SweepResultData.getVerificationJsonPromise(exp.id, currentProjectId);
      if (res) {
        let currentInterfaces = SweepResultData.getInterfaces(exp.id);
        Interfaces[exp.id] = currentInterfaces;
      }
    }
    this.setState({
      Interfaces
    }, () => {
      this.changeResult();
    })
  }

  changeResult = async () => {
    const events = {
      changeMouse: this.changeMouse,
      cancelMove: this.cancelMove,
      changeAxis: this.childComp.changeAxis,
    }
    Parameters.cleanParameters();
    this.childComp.setLoading(true)
    this.setState({
      resultList: {}
    }, async () => {
      this.mounted = true;
      const { currentProjectId: projectId, experimentList } = this.props;
      const { parameter, value } = this.childComp.getSetting();
      this.plot2d = Parameters.createPlot(this.childComp.svgRef.current, { param: parameter, value }, events);
      let files = []
      for (let item of experimentList) {
        const params = await Parameters.getParametersInfo({ verificationId: item.id, verificationSubId: item.id, projectId, channelList: item.channelList, groupName: item.name })
        const parametersArr = Array.from(params.values());
        if (parametersArr.length > 0) {
          let _files = Array.from(params.values()).map(item => ({ ...item, show: true }));
          let fileId = files.map(f => f.id);
          if (_files && _files.length) {
            files.push(..._files.filter(f => !fileId.includes(f.id)));
          }
        }
      }
      const displayMode = this.childComp.getDisplayMode();
      let expandedKeys = [RESULT];
      this.getAllNpi(files).then(res => {
        this.childComp.setLoading(false);
        const __files = [...res.map(item => ({ ...item, show: true, rowName: item.pcb, rowId: item.pcb }))];
        const newFiles = this.mergeFiles(__files)
        expandedKeys = [...new Set([...expandedKeys, ...newFiles.map(item => item.name)])]
        this.setState({
          files: __files,
          displayFiles: this.mergeFiles(__files),
          expandedKeys
        }, () => {
          displayMode === 'Default' ? this.defaultResultList() : this.findResultList();
        })
      }, error => {
        this.childComp.setLoading(false)
        this.setState({
          files: files,
          expandedKeys: [RESULT]
        }, () => {
          displayMode === 'Default' ? this.defaultResultList() : this.findResultList();
        })
      })
      this.childComp.screenChange();
    })
  }

  getAllNpi = (files) => {
    const { Interfaces } = this.state;
    const promiseList = files.map((item, index) => {
      const content = Interfaces[item.verificationId].find(d => item.id.includes(d.pcbId));
      return item.getExperimentNpiFile(index, item.verificationId, content);
    })
    return Promise.all(promiseList);
  }

  getSingleNpi = (file) => {
    const { files } = this.state;
    const { verificationSubId } = this.props;
    let length = files.length >= 0 ? files.length : 0;
    const promiseList = file.map((item, index) => {
      return item.getExperimentNpiFile(length, verificationSubId);
    })
    return Promise.all(promiseList);
  }

  getColorByIndex = (fileId, row, col) => {
    const { files } = this.state;
    const _file = files.find(file => file.id === fileId);
    return _file && _file.matrix && _file.matrix[row] && _file.matrix[row][col] ? _file.matrix[row][col].color : "";
  }

  getDefaultExpandedKeys = () => {
    const { files } = this.state;
    return [RESULT, ...new Set(files.map(item => item.id))];
  }

  defaultResultList = (key) => {
    const { resultList, files, Interfaces, keepSelect, allPortSelect, resultOpera } = this.state;
    const { experimentList } = this.props;
    let _resultList = resultList ? resultList : {};
    let _allPortSelect = allPortSelect ? allPortSelect : {};
    let _Interfaces = [];
    const { portSelect = {} } = resultOpera
    let _portSelect = { ...portSelect }
    for (let exp of experimentList) {
      const currentInterface = Interfaces[exp.id] ? Interfaces[exp.id] : []
      _Interfaces.push(...currentInterface.map(item => ({ ...item, groupName: exp.name })));
    }
    if (this.selectAllCancelAble) {
      this.selectAllCancelAble.cancel();
    }
    let _expandedKeys = this.getDefaultExpandedKeys();
    let pcbs = _Interfaces.map(item => ({ pcb: item.pcb, groupName: item.groupName }));
    for (let _interface of _Interfaces) {
      const pcb = _interface.pcb;
      const groupName = _interface.groupName;
      const fileIndex = files.findIndex(file => file.pcb === pcb && file.groupName === groupName);
      if (fileIndex < 0) {
        continue;
      }
      const findFile = files[fileIndex];
      if (!findFile.ports || !findFile.ports.length) {
        continue;
      }

      const portList = findFile.ports;
      const fileId = files[fileIndex].id;
      if (!_resultList[pcb]) {
        _resultList[pcb] = {};
      }
      if (!_allPortSelect[pcb]) {
        _allPortSelect[pcb] = {
          Default: {}
        };
      }
      if (!_allPortSelect[pcb].Default) {
        _allPortSelect[pcb].Default = {}
      }

      if (!_resultList[pcb].Default) {
        let _default = [];
        for (let i = 0; i < portList.length; i++) {
          const port = portList[i];
          const name = `Port ${port.index} (${port.name})`
          if (!_allPortSelect[pcb].Default[name]) {
            _allPortSelect[pcb].Default[name] = []
          }
          _default[i] = { rowName: name, id: `${name}::${fileId}`, children: [], groupName: [groupName], type: RESULT_TREE_SIGNAL, className: 'result-parameter-tree-signal-node-title' };
          _default[i].children = portList.map(_port => {
            _allPortSelect[pcb].Default[name].push(`${fileId}::${port.index - 1}::${_port.index - 1}`)
            return {
              id: `${fileId}::${port.index - 1}::${_port.index - 1}`,
              name: `S(${port.index}, ${_port.index}) ${port.index !== _port.index ? _port.name : ''}`,
              color: { [groupName]: this.getColorByIndex(fileId, port.index - 1, _port.index - 1) },
              type: RESULT_TREE_SWEEP_PIN,
              parentKey: `${name}::${fileId}`,
              className: "result-parameter-tree-node-title",
            }
          })
        }
        let show = _default[0] ? [_default[0].rowName] : [];
        if (keepSelect) {
          const { portSelect } = this.state;
          const keys = Object.keys(portSelect);
          show = _default.map(item => item.rowName).filter(item => keys.includes(item))
        }
        _resultList[pcb].Default = { list: _default, show };
      } else if (_resultList[pcb].Default) {
        let list = _resultList[pcb].Default.list;
        for (let i = 0; i < portList.length; i++) {
          const port = portList[i];
          let _rowName = `Port ${port.index} (${port.name})`;
          let findIndex = list.findIndex(l => l.rowName === _rowName);
          if (!_allPortSelect[pcb].Default[_rowName]) {
            _allPortSelect[pcb].Default[_rowName] = []
          }
          if (findIndex > -1) {
            _resultList[pcb].Default.list[findIndex].groupName.push(groupName);
            _resultList[pcb].Default.list[findIndex].children.forEach((child, index) => {
              _allPortSelect[pcb].Default[_rowName] = [...new Set([..._allPortSelect[pcb].Default[_rowName], `${fileId}::${port.index - 1}::${index}`])]
              child.color[groupName] = this.getColorByIndex(fileId, port.index - 1, index);
            })
          } else {
            let _default = { rowName: _rowName, id: `${_rowName}::${fileId}`, children: [], groupName: [groupName], type: RESULT_TREE_SIGNAL, className: 'result-parameter-tree-signal-node-title' };
            _default.children = portList.map(_port => {
              _allPortSelect[pcb].Default[_rowName] = [...new Set([..._allPortSelect[pcb].Default[_rowName], `${fileId}::${port.index - 1}::${_port.index - 1}`])]
              return {
                id: `${fileId}::${port.index - 1}::${_port.index - 1}`,
                name: `S(${port.index}, ${_port.index}) ${port.index !== _port.index ? _port.name : ''}`,
                color: { [groupName]: this.getColorByIndex(fileId, port.index - 1, _port.index - 1) },
                type: RESULT_TREE_SWEEP_PIN,
                parentKey: `${_rowName}::${fileId}`,
                className: "result-parameter-tree-node-title",
              }
            })
            _resultList[pcb].Default.list.push(_default)
          }
        }
      }
      if (key) {
        _portSelect = this._changePortSelect(_allPortSelect[pcb], key, _portSelect)
      }
      _resultList[pcb].Default.list && _resultList[pcb].Default.list[0] && _expandedKeys.push(_resultList[pcb].Default.list[0].id);
    }
    this.setState({
      resultList: _resultList,
      allPortSelect: _allPortSelect,
      portSelect: _portSelect,
      expandedKeys: _expandedKeys
    }, () => {
      if (Object.keys(portSelect).length) {
        this.showSavedCurves();
        return;
      }
      if (!this.state.keepSelect) {
        let _portSelect = {}, newPorts = [];
        pcbs.forEach(p => {
          const _findFile = files.find(item => item.pcb === p.pcb && item.groupName === p.groupName);
          const currentList = _resultList[p.pcb];
          if (_findFile && currentList && currentList.Default && currentList.Default.list && currentList.Default.list.length > 0 && currentList.Default.list[0].children[0]) {
            const defaultList = currentList.Default.list[0];
            const defaultValues = defaultList.children[0].id;
            const defaultKey = defaultList.rowName;
            const id = strDelimited(defaultValues, "@")[1];
            const portId = `${p.groupName}@${id}`
            _portSelect[defaultKey] = [...(_portSelect[defaultKey] || []), portId];
            newPorts.push(portId)
          }
        })
        this.setState({
          portSelect: _portSelect
        }, () => {
          this.updateSelectCurves(newPorts, null)
        })
      } else {
        this.removeUnselectPorts();
        this.setState({
          keepSelect: false
        })
      }
    })
  }

  findResultList = (key) => {
    const { files, Interfaces, resultList, allPortSelect, resultOpera } = this.state;
    const { experimentList } = this.props;
    let _Interfaces = [];
    let _resultList = resultList ? resultList : {};
    let _allPortSelect = allPortSelect ? allPortSelect : {};
    const { portSelect = {} } = resultOpera
    let _portSelect = { ...portSelect }
    for (let exp of experimentList) {
      const currentInterface = Interfaces[exp.id] ? Interfaces[exp.id] : []
      _Interfaces.push(...currentInterface.map(item => ({ ...item, groupName: exp.name })));
    }
    if (this.selectAllCancelAble) {
      this.selectAllCancelAble.cancel();
    }

    let _expandedKeys = this.getDefaultExpandedKeys();;
    const displayMode = this.childComp.getDisplayMode();
    let edit = false;
    for (let _interface of _Interfaces) {
      const pcb = _interface.pcb;
      const groupName = _interface.groupName;
      const fileIndex = files.findIndex(file => file.pcb === pcb && file.groupName === groupName);
      if (fileIndex < 0) {
        continue;
      }
      const findFile = files[fileIndex];
      if (!findFile.ports || !findFile.ports.length) {
        continue;
      }
      const content = _interface.content ? _interface.content : {};
      const { signals, components, virtualComps } = content;
      if (!_resultList[pcb]) {
        _resultList[pcb] = {};
      }

      if (!_resultList[pcb].IL || !_resultList[pcb].RL) {
        edit = true;
        const portList = findFile.ports;
        const { IL, RL, portSelect, FEXT, NEXT } = getResultList({
          Signals: signals,
          Components: components,
          VirtualComps: virtualComps,
          portList,
          getColorByIndex: this.getColorByIndex,
          infoList: ["IL", "RL", "FEXT", "NEXT"],
          fileId: findFile.id,
          portSelects: _allPortSelect[pcb],
          isSweep: true
        });
        _allPortSelect[pcb] = portSelect
        _resultList[pcb].IL = { list: this.saveColorAsArray(IL, groupName), show: IL.map(item => item.rowName), groupName: [groupName] };
        _resultList[pcb].RL = { list: this.saveColorAsArray(RL, groupName), show: RL.map(item => item.rowName), groupName: [groupName] };
        _resultList[pcb].FEXT = { list: this.saveColorAsArray(FEXT, groupName), show: FEXT.map(item => item.rowName), groupName: [groupName] };
        _resultList[pcb].NEXT = { list: this.saveColorAsArray(NEXT, groupName), show: NEXT.map(item => item.rowName), groupName: [groupName] };
      } else if (_resultList[pcb].IL && _resultList[pcb].RL &&
        (!_resultList[pcb].IL.groupName.includes(groupName) || !_resultList[pcb].RL.groupName.includes(groupName))) {
        edit = true;
        const portList = findFile.ports;
        const { IL, RL, portSelect, FEXT, NEXT } = getResultList({
          Signals: signals,
          Components: components,
          portList,
          getColorByIndex: this.getColorByIndex,
          infoList: ["IL", "RL", "FEXT", "NEXT"],
          fileId: findFile.id,
          portSelects: _allPortSelect[pcb],
          isSweep: true
        });
        _allPortSelect[pcb] = portSelect
        _resultList[pcb].IL.list = this.mergeResultList(_resultList[pcb].IL.list, IL, groupName);
        _resultList[pcb].IL.groupName.push(groupName);
        _resultList[pcb].RL.list = this.mergeResultList(_resultList[pcb].RL.list, RL, groupName);
        _resultList[pcb].RL.groupName.push(groupName);
        _resultList[pcb].FEXT.list = this.mergeResultList(_resultList[pcb].FEXT.list, FEXT, groupName);
        _resultList[pcb].FEXT.groupName.push(groupName);
        _resultList[pcb].NEXT.list = this.mergeResultList(_resultList[pcb].NEXT.list, NEXT, groupName);
        _resultList[pcb].NEXT.groupName.push(groupName);
      }
      if (key) {
        _portSelect = this._changePortSelect(_allPortSelect[pcb], key, _portSelect)
      }
      if (_resultList[pcb][displayMode]) {
        _expandedKeys.push(..._resultList[pcb][displayMode].list.map(it => it.id));
      }
    }
    this.setState({
      portSelect: _portSelect,
      expandedKeys: _expandedKeys
    }, () => {
      if (Object.keys(portSelect).length) {
        this.showSavedCurves();
      }
    })

    if (edit) {
      this.setState({
        resultList: _resultList,
        allPortSelect: _allPortSelect,
      });
    }
  }

  showSavedCurves = () => {
    const { portSelect, resultList } = this.state;
    const displayMode = this.childComp.getDisplayMode();
    const showCurvesIds = [];
    const pcbs = Object.keys(resultList);
    const rowNames = Object.keys(portSelect);
    const _resultList = { ...resultList };
    for (let pcb of pcbs) {
      const results = resultList[pcb];
      const result = results[displayMode];
      const filterRowNames = result.list.filter(item => rowNames.includes(item.rowName)).map(item => item.rowName);
      _resultList[pcb][displayMode].show = filterRowNames;
      filterRowNames.forEach(name => showCurvesIds.push(...(portSelect[name] || [])))
    }
    this.setState({
      resultList: _resultList
    }, () => {
      setTimeout(() => {
        this.showCurves(showCurvesIds)
      }, 500)
    })
  }

  _changePortSelect = (pcbPortSelectData, key, _portSelect) => {

    if (key === 'Default') {
      let new_portSelect = {}
      const keys = Object.keys(pcbPortSelectData[key])
      for (const k of keys) {
        if (_portSelect && _portSelect[k] && _portSelect[k].length) {
          new_portSelect[k] = _portSelect[k]
        }
      }
      _portSelect = new_portSelect
    } else {
      const keys = pcbPortSelectData && pcbPortSelectData[key] ? Object.keys(pcbPortSelectData[key]) : []
      for (const k of keys) {
        if (_portSelect && _portSelect[k] && _portSelect[k].length) {
          const filterData = _portSelect[k].filter(item => pcbPortSelectData[key][k].includes(item))
          _portSelect[k] = [...new Set(filterData)]
        }
      }

      if (pcbPortSelectData.Default) {
        const default_keys = Object.keys(pcbPortSelectData.Default)
        for (const k of default_keys) {
          if (_portSelect && _portSelect[k] && _portSelect[k].length) {
            _portSelect[k] = []
          }
        }
      }
    }

    return _portSelect
  }

  changeSelectAll = (e, type, expName, signalId, nodeData) => {
    let { portSelect, allPortSelect, files } = this.state;
    const checked = e.target.checked;
    let delIds = [], newIds = []
    const displayMode = this.childComp.getDisplayMode()
    if (type === "exp") {
      //nodeData.name -> file id. nodeData -> PCB item
      const pcbPortSelect = allPortSelect[nodeData.pcb] || {};//{pcb:{RL: { signal:[port] },IL,NEXT,Default}}
      const currAllPortSelect = pcbPortSelect[displayMode] || {};

      for (let signal in currAllPortSelect) {
        const allPorts = currAllPortSelect[signal].filter(item => strDelimited(item, '@')[0] === expName);
        if (checked) {
          newIds.push(...allPorts.filter(item => !(portSelect[signal] || []).includes(item)));
          portSelect[signal] = [...new Set([...(portSelect[signal] || []), ...allPorts])]
        } else {
          delIds.push(...allPorts.filter(item => (portSelect[signal] || []).includes(item)));
          portSelect[signal] = (portSelect[signal] || []).filter(item => !allPorts.includes(item));
        }
      }
    }

    if (type === "signal") {
      const [signal, fileId] = strDelimited(signalId, "::");
      const file = files.find(item => item.id === fileId);
      if (!file) {
        return;
      }
      const pcbPortSelect = allPortSelect[file.pcb] || {};//{pcb:{RL: { signal:[port] },IL,NEXT,Default}}
      const currAllPortSelect = pcbPortSelect[displayMode] || {};
      const rowKeys = (currAllPortSelect[signal] || []).filter(item => strDelimited(item, '@')[0] === expName);//Base@pcb_4455124502896_4455128134688.s8p::0::0
      if (checked) {
        newIds = rowKeys.filter(item => !(portSelect[signal] || []).includes(item))
        portSelect[signal] = [...new Set([...(portSelect[signal] || []), ...rowKeys])];
        delIds = [];
      } else {
        delIds = rowKeys.filter(item => (portSelect[signal] || []).includes(item))
        portSelect[signal] = (portSelect[signal] || []).filter(item => !rowKeys.includes(item));
        newIds = [];
      }
    }
    this.updateSelectCurves(newIds, delIds)
    this.setState({
      portSelect: portSelect
    }, () => {
      this.setResultOpera({ portSelect })
    })
  }

  changeSinglePort = (e, signalId, portId) => {
    const { portSelect } = this.state;
    if (!signalId || !portId) {
      return;
    }
    const signal = strDelimited(signalId, "::")[0];

    let newIds = [], delIds = []

    const checked = e.target.checked;
    if (checked) {
      portSelect[signal] = [...new Set([...(portSelect[signal] || []), portId])];
      newIds = [portId];
    } else {
      portSelect[signal] = (portSelect[signal] || []).filter(item => item !== portId);
      delIds = [portId];
    }

    this.updateSelectCurves(newIds, delIds)
    this.setState({ portSelect }, () => { this.setResultOpera({ portSelect }); })
  }

  updateSelectCurves = (newIds, delIds) => {
    delIds && delIds.forEach(uncheck => {
      const [fileId, row, col] = strDelimited(uncheck, "::");
      Parameters.removeCurve({ row, col, id: fileId });
    })
    newIds && newIds.length && this.showDataCurves(newIds)
  }

  setChannelState = (value, key) => {
    this.setState({
      key: value
    })
  }

  updateExpandKeys = (keys) => {
    this.setState({
      expandedKeys: keys
    })
  }

  getSweepChecked = (expName, signalId, nodeData) => {
    const { portSelect, allPortSelect, files } = this.state;
    if (!allPortSelect || !portSelect || !Object.keys(allPortSelect).length || !Object.keys(portSelect).length) {
      return {
        checked: false,
        indeterminate: false
      }
    }
    const displayMode = this.childComp.getDisplayMode();
    if (signalId) {
      //pcb exp signal
      //signalId - BOOTMODE_I2C_SCL::Base@pcb_4401143644672_4455128134688.s8p
      const [signal, fileId] = strDelimited(signalId, "::");
      const file = files.find(item => item.id === fileId);
      if (!file || !allPortSelect[file.pcb]) {
        return {
          checked: false,
          indeterminate: false
        };
      }
      const signalPortSelect = portSelect[signal] || [];
      const pcbPortSelect = allPortSelect[file.pcb][displayMode] || {};
      const allKeys = (pcbPortSelect[signal] || []).filter(item => strDelimited(item, '@')[0] === expName);
      const checked = allKeys.every(item => signalPortSelect.includes(item));
      return {
        checked,
        indeterminate: !checked && allKeys.some(item => signalPortSelect.includes(item))
      }
    } else {
      //pcb exp
      if (!allPortSelect[nodeData.pcb]) {
        return {
          checked: false,
          indeterminate: false
        };
      }

      const pcbPortSelect = allPortSelect[nodeData.pcb][displayMode] || {};
      //expName -  base::pcb
      const allKeys = Object.keys(pcbPortSelect).map(item => pcbPortSelect[item].filter(name => strDelimited(name, '@')[0] === expName)).flat(2);
      const selectedKeys = Object.keys(portSelect).map(item => portSelect[item]).flat(2);
      const checked = allKeys.every(item => selectedKeys.includes(item));
      return {
        checked,
        indeterminate: !checked && allKeys.some(item => selectedKeys.includes(item))
      }
    }
  }

  changeTreeCheckedKeys = ({ checked, nodeData }) => {
    const { allPortSelect, portSelect, files } = this.state;
    let _portSelect = { ...portSelect };
    const displayMode = this.childComp.getDisplayMode();
    let newIds = [], delIds = [], allValues = [], signal = "";
    if (nodeData.children) {
      //row signal Name - BOOTMODE_I2C_SCL::Base@pcb_4401143644672_4455128134688.s8p
      const [_signal, fileId] = strDelimited(nodeData.id, "::");
      signal = _signal;
      const file = files.find(item => item.id === fileId);
      if (!file) {
        return;
      }
      if (!_portSelect[signal]) {
        _portSelect[signal] = []
      }
      const pcbPortSelect = allPortSelect[file.pcb][displayMode];
      allValues = [...(pcbPortSelect[signal] || [])];

    } else {
      //id - Base@pcb_4401143644672_4455128134688.s8p::0::0
      //parentKey - BOOTMODE_I2C_SCL::Base@pcb_4401143644672_4455128134688.s8p
      const [_signal, fileId] = strDelimited(nodeData.parentKey, "::");
      signal = _signal;
      const file = files.find(item => item.id === fileId);
      if (!file) {
        return;
      }
      if (!_portSelect[signal]) {
        _portSelect[signal] = []
      }
      const portId = strDelimited(nodeData.id, "@")[1];
      const pcbPortSelect = allPortSelect[file.pcb][displayMode];
      allValues = [...(pcbPortSelect[signal] || [])].filter(item => item.match(portId));
    }

    //update select curve
    newIds = checked ? allValues.filter(item => !_portSelect[signal].includes(item)) : [];
    delIds = checked ? [] : allValues.filter(item => _portSelect[signal].includes(item));
    //update port select
    _portSelect[signal] = _portSelect[signal].filter(item => !allValues.includes(item))
    checked && _portSelect[signal].push(...allValues);

    this.updateSelectCurves(newIds, delIds)
    this.setState({ portSelect: _portSelect }, () => { this.setResultOpera({ portSelect: _portSelect }); })

  }

  getAllPortKeys = (allPortSelect, displayMode, experimentNames) => {
    let allKeys = []
    for (let pcb in allPortSelect) {
      if (!allPortSelect[pcb][displayMode]) {
        continue;
      }
      const currObj = allPortSelect[pcb][displayMode] || {};
      for (let signal in currObj) {
        allKeys.push(...(currObj[signal] || []));
      }
    }
    return allKeys.filter(item => item.match(new RegExp(`^(${experimentNames.join("|")})`, "i")));
  }

  getSweepTreeCheckedKeys = (displayMode) => {
    const { allPortSelect, portSelect, files } = this.state;

    if (!allPortSelect || !portSelect || !Object.keys(allPortSelect).length || !Object.keys(portSelect).length) {
      return { checked: [], halfChecked: [] }
    }

    const { experimentList } = this.props;
    const experimentNames = experimentList.map(item => item.name);
    const currAllSelect = this.getAllPortKeys(allPortSelect, displayMode, experimentNames);//[Base@pcb_4455124502896_4455128134688.s8p::0::0,...]
    const allBaseCompPinKeys = currAllSelect.filter(item => item.match(new RegExp(`^(${experimentNames.join("|")})`, "i")));     //[Base@pcb_4455124502896_4455128134688.s8p::0::0]

    let checked = [], halfChecked = [];
    //comp pin checked - Base@pcb_4455124502896_4455128134688.s8p::0::0
    const selectedKeys = Object.keys(portSelect).map(item => portSelect[item]).flat(2);
    for (let key of allBaseCompPinKeys) {
      const portId = strDelimited(key, "@")[1];
      const currKeys = currAllSelect.filter(item => item.match(portId));
      const isAllChecked = currKeys.every(item => selectedKeys.includes(item));
      if (isAllChecked) {
        checked.push(key);
      } else if (currKeys.some(item => selectedKeys.includes(item))) {
        halfChecked.push(key);
      }
    }

    let signalChecked = [], signalHalfChecked = [];
    //signal checked -BOOTMODE_I2C_SCL::Base@pcb_4401143644672_4455128134688.s8p
    for (let file of files) {
      if (file.type === "end-to-end" || !allPortSelect[file.pcb] || !allPortSelect[file.pcb][displayMode]) {
        continue;
      }

      const pcbPortSelect = allPortSelect[file.pcb][displayMode];
      for (let key in pcbPortSelect) {
        const portSelectedKeys = pcbPortSelect[key].filter(item => item.match(new RegExp(`^(${experimentNames.join("|")})`, "i")));
        const allChecked = portSelectedKeys.every(item => selectedKeys.includes(item));
        if (allChecked) {
          signalChecked.push(`${key}::${file.id}`)
        } else if (portSelectedKeys.some(item => selectedKeys.includes(item))) {
          signalHalfChecked.push(`${key}::${file.id}`)
        }
      }
    }

    return { checked: [...checked, ...signalChecked], halfChecked: [...halfChecked, ...signalHalfChecked] }
  }

  render() {
    const { portSelect, resultList, displayFiles, allPortSelect, resultOpera, expandedKeys } = this.state;
    const { experimentList } = this.props;
    return <Sparameter
      onRef={(ref) => { this.childComp = ref }}
      files={displayFiles}
      portSelect={portSelect}
      resultList={resultList}
      plot2d={this.plot2d}
      sweep={true}
      setChannelState={this.setChannelState}
      defaultResultList={this.defaultResultList}
      findResultList={this.findResultList}
      experimentList={experimentList}
      settingChangeCB={this.settingChangeCB}
      allPortSelect={allPortSelect}
      className="sierra-sweep-sparameter-result"
      resultOpera={resultOpera}
      setResultOpera={this.setResultOpera}
      expandedKeys={expandedKeys}
      {...this.resultListAction}
    />
  }

  showDataCurves = (idList) => {
    const { files } = this.state;
    const setting = this.childComp.getSetting();
    const curves = idList.map(d => {
      const [fileId, row, col] = strDelimited(d, "::");
      let parameter = Parameters.getParameter(fileId);
      if (!parameter) {
        return null;
      }
      const curveType = parameter.type; // simulation || target
      let fileIndex = files.findIndex(item => item.id === fileId);
      if (!files[fileIndex].ports || !parameter.ports) {
        return null;
      };
      return { parameter, fileIndex, row, col, curveType }
    });
    const _showCurves = sparameterShowCurves({
      parameters: Parameters,
      curves,
      param: setting.parameter,
      value: setting.value,
      sweep: true,
      files
    });
    this.selectAllCancelAble = makeCancelable(_showCurves)
    this.selectAllCancelAble.promise.then(resCurves => {
      if (resCurves) {
        this.plot2d.updateCurves(resCurves, true);
        resCurves.forEach(cur => {
          const _fileIndex = files.findIndex(item => item.id === cur.id);
          const color = files[_fileIndex].matrix[cur.row][cur.col].color;
          this.plot2d.resetColor({ id: cur.id, row: cur.row, col: cur.col, color: color });
        })
        this.plot2d.resetPlot();
        const axis = this.childComp.getAxis();
        const setting = this.childComp.getSetting();
        if (Parameters.getSize() > 0) {
          Parameters.changeAxis('x', { param: setting.parameter, value: setting.value, scale: axis.xScale });
          Parameters.changeAxis('y', { param: setting.parameter, value: setting.value, scale: axis.yScale });
        }
      };
    })
  }

  showCurve = (newCheck) => {
    const { files } = this.state;
    const setting = this.childComp.getSetting();
    const displayMode = this.childComp.getDisplayMode()
    let [id, row, col] = strDelimited(newCheck, "::");
    let parameter = Parameters.getParameter(id);
    if (!parameter) {
      return;
    }
    const curveType = parameter.type; // simulation || target
    let fileIndex = files.findIndex(item => item.id === id);
    if (!files[fileIndex].ports || !files[fileIndex].ports.length || !parameter.ports || !parameter.ports.length) {
      return;
    }
    Parameters.showCurve({ parameter, fileIndex, row, col, param: setting.parameter, value: setting.value, curveType, sweep: true }).then(curves => {
      if (curves) {
        if (displayMode !== this.childComp.getDisplayMode()) { return }
        files[fileIndex].matrix[row][col][curves.type] = curves.y;
        curves.visible = true;
        this.plot2d.updateCurves(curves, true);
        this.plot2d.resetPlot();
        if (!files[fileIndex].matrix || !files[fileIndex].matrix.length) {
          return;
        }
        const color = files[fileIndex].matrix[row][col].color;
        this.plot2d.resetColor({ id, row, col, color: color });
        const axis = this.childComp.getAxis();
        const setting = this.childComp.getSetting();
        Parameters.changeAxis('x', { param: setting.parameter, value: setting.value, scale: axis.xScale });
        Parameters.changeAxis('y', { param: setting.parameter, value: setting.value, scale: axis.yScale });
      }
    });
  }

  showCurves = (newChecks) => {
    const { files } = this.state;
    const setting = this.childComp.getSetting();
    const curves = newChecks.map(d => {
      const [fileId, row, col] = strDelimited(d, "::");
      let parameter = Parameters.getParameter(fileId);
      if (!parameter) {
        return null;
      }
      const curveType = parameter.type; // simulation || target
      let fileIndex = files.findIndex(item => item.id === fileId);
      if (!files[fileIndex].ports || !parameter.ports) {
        return null;
      };
      return { parameter, fileIndex, row, col, curveType }
    });
    Parameters.showCurves({ curves, param: setting.parameter, value: setting.value, sweep: true }).then(resCurves => {
      if (resCurves) {
        resCurves.forEach(cur => {
          const _fileIndex = files.findIndex(item => item.id === cur.id);
          files[_fileIndex].matrix[cur.row][cur.col][cur.type] = cur.y;
          cur.visible = true;
        })
        this.plot2d && this.plot2d.updateCurves(resCurves, true);
        resCurves.forEach(cur => {
          const _fileIndex = files.findIndex(item => item.id === cur.id);
          const color = files[_fileIndex].matrix[cur.row][cur.col].color;
          this.plot2d.resetColor({ id: cur.id, row: cur.row, col: cur.col, color: color });
        })
        this.plot2d.resetPlot();
        const axis = this.childComp.getAxis();
        const setting = this.childComp.getSetting();
        if (Parameters.getSize() > 0) {
          Parameters.changeAxis('x', { param: setting.parameter, value: setting.value, scale: axis.xScale });
          Parameters.changeAxis('y', { param: setting.parameter, value: setting.value, scale: axis.yScale });
        }
      };
    });
  }

  colorChange = (e, key) => {
    const [id, row, col] = strDelimited(key, "::");
    const [groupName, name] = strDelimited(key, "@")
    const { files, resultList } = this.state;
    const displayMode = this.childComp.getDisplayMode();
    let fileIndex = files.findIndex(item => item.id === id);
    const pcb = files[fileIndex].pcb;
    let _resultList = resultList[pcb];
    const value = e.toHexString()
    if (value) {
      files[fileIndex].matrix[row][col].color = value;
      for (let group of _resultList[displayMode].list) {
        let _find = false;
        for (let child of group.children) {
          if (child.id.includes(name)) {
            child.color[groupName] = value;
            _find = true;
            break;
          }
        }
        if (_find) {
          break;
        }
      }
      this.setState({
        files,
        resultList: { ...resultList, pcb: _resultList }
      }, () => {
        this.plot2d.resetColor({ id, row: row, col: col, color: value })
        this.plot2d.redrawCurves();
      })
    }
  }

  mergeFiles = (files) => {
    let _files = [];
    for (let file of files) {
      let current = _files.find(f => f.pcb === file.pcb);
      if (!current) {
        _files.push(file);
      }
    }
    return _files;
  }

  saveColorAsArray = (group, groupName) => {
    let newGroup = [...group];
    newGroup = group.map(item => {
      const _children = item.children.map(child => {
        const color = child.color;
        return { ...child, color: { [groupName]: color } }
      })

      return { ...item, children: _children, groupName: [groupName] }
    })
    return newGroup
  }

  mergeResultList = (group, result, _groupName) => {
    let newList = [];
    for (let item of group) {
      const { rowName, groupName, children } = item;
      const findItem = result.find(r => r.rowName === rowName);
      if (findItem) {
        let newGroupName = [...groupName, _groupName];
        let newChildren = children.map(child => {
          let color = child.color;
          const findChild = findItem.children.find(c => c.name === child.name);
          if (findChild) {
            color[_groupName] = findChild.color;
          }
          return { ...child, color }
        })
        newList.push({ ...item, rowName, groupName: newGroupName, children: newChildren })
      }
    }
    let listName = newList.map(item => item.rowName);
    let moreResults = result.filter(r => !listName.includes(r.rowName));
    newList.push(...this.saveColorAsArray(moreResults, _groupName))
    return newList
  }

  settingChangeCB = () => {
    const { files } = this.state;
    const axis = this.childComp.getAxis();
    const setting = this.childComp.getSetting();
    Parameters.changeParameter({ parameters: files, setting, yScale: axis.yScale, xScale: axis.xScale, sweep: true });
    this.setResultOpera({ setting, axis })
  }

  removeUnselectPorts = () => {
    const { experimentList } = this.props;
    let { portSelect } = this.state;
    const nameGroup = experimentList.map(item => item.name);
    let newPortSelect = { ...portSelect };
    const keys = Object.keys(newPortSelect);
    for (let key of keys) {
      if (newPortSelect[key] && newPortSelect[key].length) {
        let newList = [];
        newPortSelect[key].forEach(item => {
          const [groupName] = strDelimited(item, "@");
          if (nameGroup.includes(groupName)) {
            newList.push(item)
            this.showCurve(item)
          } else {
            const [fileId, row, col] = strDelimited(item, "::");
            Parameters.removeCurve({ row, col, id: `${fileId}` });
          }
        })
        newPortSelect[key] = newList;
      }
    }
    this.setState({ portSelect: newPortSelect }, () => {
      this.setResultOpera({ portSelect: newPortSelect })
    })
  }

  setResultOpera = (newSetting) => {
    const { expVerificationId } = this.props;
    const { resultOpera } = this.state;
    this.setState({
      resultOpera: { ...resultOpera, ...newSetting }
    }, () => {
      resultOperation.setOperationByKey(expVerificationId, CHANNEL, { ...resultOpera, ...newSetting })
    })
  }

  resultListAction = {
    colorChange: this.colorChange,
    changeSelectAll: this.changeSelectAll,
    updateExpandKeys: this.updateExpandKeys,
    getSweepChecked: this.getSweepChecked,
    changeSinglePort: this.changeSinglePort,
    changeTreeCheckedKeys: this.changeTreeCheckedKeys,
    getSweepTreeCheckedKeys: this.getSweepTreeCheckedKeys
  }
}

const mapState = (state) => {
  const { project, sweep: { experimentInfo } } = state.SierraReducer;
  const { currentProjectId } = project;
  const { id = "", resultList = [] } = experimentInfo;
  const expVerificationId = resultList.length ? resultList[0].verificationId : "";
  return {
    currentProjectId,
    sweepId: id,
    expVerificationId
  }
}

export default connect(mapState, null)(SweepChannel);